function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import ReactTooltip from 'react-tooltip';
import moment from 'moment';
import { FormattedMessage } from 'react-intl';
import cn from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';
import forEach from 'lodash/forEach';
import forOwn from 'lodash/forOwn';
import filter from 'lodash/filter';
import find from 'lodash/find';
import get from 'lodash/get';
import includes from 'lodash/includes';
import map from 'lodash/map';
import reduce from 'lodash/reduce';
import slice from 'lodash/slice';
import sortBy from 'lodash/sortBy';
import startsWith from 'lodash/startsWith';
import toLower from 'lodash/toLower';
import { formatDateAsObject, formatTimestamp } from 'helpers/datetime';
import Avatar from 'components/Avatar';
import CheckboxRadio from 'components/Form/CheckboxRadio';
import Pagination from 'components/Pagination';
import SyncIcon from 'svg/sync.svg';
import App from 'modules/App';
import DataSources from 'modules/DataSources';
import * as actions from '../../actions';
import * as selectors from '../../selectors';
import messages from '../../messages';
import styles from './ImportsHistory.pcss';
var _React_PureComponent;
class ImportsHistory extends (_React_PureComponent = React.PureComponent) {
    static getDerivedStateFromProps(props, state) {
        // eslint-disable-next-line react/prop-types
        const { phiSet, devices } = props;
        const imports = get(phiSet, 'imports');
        if (state.imports !== imports) {
            if (!imports) {
                return {
                    imports,
                    importDocuments: [],
                    matchedDevices: {},
                    totalPages: 1,
                    page: 0
                };
            }
            const matchedDevices = {};
            const setDevice = (serialNumberToken)=>{
                const foundDevices = filter(devices, (device)=>startsWith(serialNumberToken, device.sku));
                matchedDevices[serialNumberToken] = reduce(foundDevices, (acc, matchedDevice)=>acc && acc.sku.length > matchedDevice.sku.length ? acc : matchedDevice, null);
            };
            const flattenImportDocuments = [];
            forOwn(imports, (deviceImports, serialNumberToken)=>{
                const { deviceName, documents } = deviceImports;
                setDevice(serialNumberToken);
                forEach(documents, (document)=>{
                    flattenImportDocuments.push(_object_spread_props(_object_spread({}, document), {
                        deviceName,
                        serialNumberToken
                    }));
                });
            });
            const importDocuments = sortBy(flattenImportDocuments, (d)=>-d.timestamp);
            const totalPages = Math.ceil(importDocuments.length / 10);
            return {
                imports,
                importDocuments,
                matchedDevices,
                totalPages,
                page: 0
            };
        }
        return null;
    }
    componentDidUpdate() {
        ReactTooltip.rebuild();
    }
    onChangePage(page) {
        this.setState({
            page
        });
    }
    onChangeFromImports(importDocumentId) {
        const { imports } = this.state;
        this.props.onChangeFromImports(importDocumentId, imports);
    }
    get importDocumentsPage() {
        const { page } = this.state;
        const perPage = 10;
        const start = page * 10;
        const end = start + perPage;
        return slice(this.state.importDocuments, start, end);
    }
    get importDocumentsByMonths() {
        const monthlyImportDocuments = {
            index: [],
            months: {}
        };
        const { importDocumentsPage } = this;
        forEach(importDocumentsPage, (importDocument, idx)=>{
            const { month, year } = formatDateAsObject(importDocument.timestamp * 1000); // Date needs ms
            const key = `${year}-${month}`;
            if (!monthlyImportDocuments.months[key]) {
                monthlyImportDocuments.index.push(key);
                monthlyImportDocuments.months[key] = {
                    importDocuments: [],
                    month: moment().month(month - 1).format('MMMM'),
                    year
                };
            }
            monthlyImportDocuments.months[key].importDocuments.push(_object_spread_props(_object_spread({}, importDocument), {
                idx
            }));
        });
        return monthlyImportDocuments;
    }
    renderColHeaders() {
        return /*#__PURE__*/ _jsxs("div", {
            className: styles.table__headers,
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: styles.table__col,
                    children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.tableLabels.timeOfImport))
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: styles.table__col,
                    children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.tableLabels.dateRange))
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: cn(styles.table__col, styles['table__col--small']),
                    children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.tableLabels.readings))
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: cn(styles.table__col, styles['table__col--small']),
                    children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.tableLabels.source))
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: cn(styles.table__col, styles['table__col--small']),
                    children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.tableLabels.filterChart))
                })
            ]
        });
    }
    renderSourceFigure(importDocument) {
        const { serialNumberToken, deviceName } = importDocument;
        if (serialNumberToken === 'sync') {
            return /*#__PURE__*/ _jsx("figure", {
                className: styles.deviceFigure,
                "data-for": "importsHistoryTooltip",
                "data-tip": "Sync",
                children: /*#__PURE__*/ _jsx(SyncIcon, {
                    className: styles.deviceFigure__icon
                })
            });
        }
        if (serialNumberToken === 'glucocontrodesktop') {
            return /*#__PURE__*/ _jsx("figure", {
                className: styles.deviceFigure,
                "data-for": "importsHistoryTooltip",
                "data-tip": "GlucoControDesktop",
                children: /*#__PURE__*/ _jsx(SyncIcon, {
                    className: styles.deviceFigure__icon
                })
            });
        }
        if (serialNumberToken === 'snaq') {
            return /*#__PURE__*/ _jsx("figure", {
                className: styles.deviceFigure,
                "data-for": "importsHistoryTooltip",
                "data-tip": "Snaq",
                children: /*#__PURE__*/ _jsx("img", {
                    src: "/assets/svg/snaq.svg",
                    alt: "snaq.io"
                })
            });
        }
        const device = get(this.state.matchedDevices, serialNumberToken);
        if (device) {
            const caseTypeId = get(device, 'caseTypeId');
            const caseType = find(this.props.caseTypes, {
                caseTypeId
            });
            const icon = get(caseType, 'icon', null);
            return /*#__PURE__*/ _jsx("figure", {
                className: styles.deviceFigure,
                "data-for": "importsHistoryTooltip",
                "data-tip": device.name,
                dangerouslySetInnerHTML: {
                    __html: icon
                }
            });
        }
        const dataSource = find(this.props.dataSources, (ds)=>toLower(ds.dataSourceProvider) === serialNumberToken);
        if (dataSource) {
            const dataSourceProvider = get(this.props.localizationResources, [
                dataSource.nameKey,
                'value'
            ], dataSource.dataSourceProvider);
            return /*#__PURE__*/ _jsx("figure", {
                className: styles.dataSource,
                "data-for": "importsHistoryTooltip",
                "data-tip": dataSourceProvider,
                children: /*#__PURE__*/ _jsx(Avatar, {
                    avatarImg: dataSource.logo,
                    name: dataSourceProvider,
                    className: styles.dataSource__logo,
                    imgClassName: styles.dataSource__logo__img,
                    initialsClassName: styles.dataSource__logo__initials
                })
            });
        }
        return /*#__PURE__*/ _jsx("figure", {
            className: styles.deviceFigure,
            "data-for": "importsHistoryTooltip",
            "data-tip": deviceName,
            children: /*#__PURE__*/ _jsx("img", {
                src: "/assets/svg/generic-glucometer.svg",
                alt: deviceName
            })
        });
    }
    renderImport(importDocument) {
        const { importDocumentId, timestamp, maxResultDate, minResultDate, readingsCount, idx } = importDocument;
        return /*#__PURE__*/ _jsxs("div", {
            className: cn(styles.table__row, {
                [styles.odd]: !(idx % 2)
            }),
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: cn(styles.table__col, 'text--bold'),
                    children: formatTimestamp(timestamp, 'L, LT')
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: styles.table__col,
                    children: [
                        formatTimestamp(minResultDate, 'L'),
                        " - ",
                        formatTimestamp(maxResultDate, 'L')
                    ]
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: cn(styles.table__col, styles['table__col--small']),
                    children: /*#__PURE__*/ _jsx("span", {
                        className: styles.readingsCount,
                        children: readingsCount
                    })
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: cn(styles.table__col, styles['table__col--small']),
                    children: this.renderSourceFigure(importDocument)
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: cn(styles.table__col, styles['table__col--small']),
                    children: /*#__PURE__*/ _jsx(CheckboxRadio, {
                        id: importDocumentId,
                        inputValue: "1",
                        value: includes(this.props.fromImports, importDocumentId) ? '1' : '',
                        onChange: ()=>this.onChangeFromImports(importDocumentId)
                    })
                })
            ]
        }, importDocumentId);
    }
    renderMonth(monthId, months) {
        const month = get(months, monthId);
        if (!month) {
            return null;
        }
        return /*#__PURE__*/ _jsxs("div", {
            className: styles.month,
            children: [
                /*#__PURE__*/ _jsxs("h3", {
                    className: styles.month__name,
                    children: [
                        /*#__PURE__*/ _jsx("p", {
                            children: month.month
                        }),
                        /*#__PURE__*/ _jsx("p", {
                            className: "mt-2",
                            children: month.year
                        })
                    ]
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: styles.month__imports,
                    children: map(month.importDocuments, (importDocument)=>this.renderImport(importDocument))
                })
            ]
        }, monthId);
    }
    render() {
        const { importDocumentsByMonths } = this;
        return /*#__PURE__*/ _jsxs("div", {
            className: styles.root,
            children: [
                this.renderColHeaders(),
                map(importDocumentsByMonths.index, (monthId)=>this.renderMonth(monthId, importDocumentsByMonths.months)),
                /*#__PURE__*/ _jsx(Pagination, {
                    perPage: 10,
                    onPageChange: (page)=>this.onChangePage(page),
                    page: this.state.page,
                    totalPages: this.state.totalPages,
                    isPerPageOff: true
                }),
                /*#__PURE__*/ _jsx(ReactTooltip, {
                    id: "importsHistoryTooltip",
                    place: "top",
                    type: "dark",
                    effect: "solid"
                })
            ]
        });
    }
    constructor(props){
        super(props);
        this.state = {
            imports: null,
            importDocuments: [],
            matchedDevices: {},
            totalPages: 1,
            page: 0
        };
    }
}
_define_property(ImportsHistory, "propTypes", {
    // Implicit props
    fromImports: PropTypes.arrayOf(PropTypes.string),
    devices: PropTypes.arrayOf(App.shapes.device),
    caseTypes: PropTypes.arrayOf(App.shapes.caseType),
    dataSources: PropTypes.arrayOf(DataSources.shapes.dataSource),
    localizationResources: PropTypes.object,
    // Implicit actions
    onChangeFromImports: PropTypes.func
});
const mapStateToProps = (state)=>({
        fromImports: selectors.fromImports(state),
        devices: App.selectors.devices(state),
        caseTypes: App.selectors.caseTypes(state),
        localizationResources: App.selectors.localizationResources(state),
        dataSources: DataSources.selectors.dataSources(state)
    });
const mapDispatchToProps = (dispatch)=>({
        onChangeFromImports: (importDocumentId, imports)=>dispatch(actions.changeFromImports(importDocumentId, imports))
    });
const ConnectedImportsHistory = connect(mapStateToProps, mapDispatchToProps)(ImportsHistory);
export default withStyles(styles)(ConnectedImportsHistory);
